import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { RecruiterProfile } from "../types";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_RECRUITER_PROFILE = "recruiterProfile";

const getData = async (props: { token: string }): Promise<RecruiterProfile> => {
  const url = `${END_POINT.BASE_URL}/v1/recruiter-profile`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  const item: RecruiterProfile = res.data;
  const data: RecruiterProfile = {
    ...item,
  };

  return data;
};
export const useGetRecruiterProfile = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_RECRUITER_PROFILE],
    () => getData({ token }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );

  return queryData;
};
